<template>
    <div>
        <div class="seachBox flex">
            <div class="seachList"><span class="name">订单号：</span>
                <a-input placeholder="" class="seachs" v-model="seach.order_num"/>
            </div>
          <div class="seachList"><span class="name">客户名称：</span>
            <a-input placeholder="" class="seachs" v-model="seach.company"/>
          </div>

          <div class="seachList"><span class="name">交易类型：</span>
            <a-select v-model="seach.trade_type	" class="seachs" allowClear   >
              <a-select-option :value="item.id" :key="index" v-for="(item,index) in service_type">
                {{item.name}}
              </a-select-option>
            </a-select>
          </div>
            <div class="seachList"><span class="name">下单时间：</span>
              <a-range-picker class="seachs" v-model="seach.order_time"  :allowClear="false" :showTime="false"  format="YYYY-MM-DD"/>
  </div>
            <div class="seachList" style="">
                <a-button type="primary" class="seachBtn" @click="getList(1)" style="margin-right: 10px"> 搜索</a-button>
                <a-button class="seachBtn" @click="resetSeach()">重置</a-button>
            </div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
        </div>

        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
                >

        </a-table>
    </div>
</template>
<script>
    import API from "./api";
    import moment from 'moment';
    const columns = [
      {
        title: "订单号",
        dataIndex: "order_num",
        ellipsis: true,
        key: "order_num",
        scopedSlots: {customRender: "order_num"}
      }, {
        title: "客户名称",
        dataIndex: "company",
        ellipsis: true,
        key: "company"
      },
      {
        title: "交易名称",
        dataIndex: "trade_name",
        ellipsis: true,
        key: "trade_name"
      },
      {
        title: "金额",
        key: "format_order_amount",
        dataIndex: "format_order_amount",
      },{
        title: "支付状态",
        key: "format_pay_status",
        dataIndex: "format_pay_status",  width: "200px",
      },{
        title: "交易详情（元）",
        key: "trade_detail",
        dataIndex: "trade_detail",
      },{
        title: "支付平台交易号",
        key: "pay_id",
        dataIndex: "pay_id",
      },{
        title: "下单时间",
        key: "format_order_time",
        dataIndex: "format_order_time",
      },{
        title: "支付时间",
        key: "format_pay_time",
        dataIndex: "format_pay_time",
      },
    ];
    export default {
        name: "OrderList",
        data() {
            return {
              service_type: [],
                resetSeachdata:true,
                page:1,
                seach: {
                  order_time:[],
                  trade_type:"",
                  company:"",
                  order_num:""
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                loading: true,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/CustomerManagement/OrderList"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList()
        },
        computed: {
        },
        components: {},
        methods: {
            resetSeach() {
                this.loading = true
                this.seach = {
                  order_time:[],
                  trade_type:"",
                  company:"",
                  order_num:""
                }
                this.resetSeachdata=false
                this.getList(1)
            },
            getList(page) {
                this.selectedRowKeys=[]
                this.page=page
                let seachData=JSON.parse(JSON.stringify(this.seach))
                if (seachData.order_time.length > 0&&this.resetSeachdata==true) {
                    seachData.order_time[0] = moment(this.seach.order_time[0]).format('YYYY-MM-DD')
                    seachData.order_time[1] = moment(this.seach.order_time[1]).format('YYYY-MM-DD')
                }else{
                    seachData.order_time=[]
                }
                API.finance.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.list.data
                    if(!this.resetSeachdata==true){
                        this.seach.order_time=[]
                        this.seach.order_time=[]
                    }
                  this.service_type=res.data.data.service_type
                    this.resetSeachdata=true
                    this.loading = false
                  this.pagination.total =  res.data.data.list.total
                  this.pagination.pageSize =  res.data.data.list.per_page
                  this.pagination.current =  res.data.data.list.current_page
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            details(id){
                this.$router.push({path: '/CustomerManagement/FeedBackDetails', query: {id:id}})
            },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name { width: 70px !important;}
    .seachBox .seachBtnBox .seachBtn{margin-top: 0!important;}
    .seachBox .seachList .seachs.white >>> .ant-input{color: #fff!important;}
    .seachBox .seachList .seachs.white >>> .ant-calendar-range-picker-separator{color: #fff!important;}
    .seachBox .seachList .seachs.white >>> .ant-calendar-picker{color: #fff!important;}
</style>
